
var Model = require("../types/Model.js");

/**
 * Handles tracking the latest messages for the current user.
 * @module GroupedMessages
 */

module.exports = Model({
	name: "livechatgroupedmessages",
	init: init,
	listeners: listeners,
});


function listeners() {
	return {
		"livechatmessages:updated": handle_messages_updated
	};
}

function init() {
	// Push an empty array as the initial state
	this.push([]);
}

function handle_messages_updated(messages) {
	var currentList = messages.list;
	if(currentList.length === 0) {
		this.push([]);
		return;
	}
	var initialValue = {
		from: null,
		current: [],
		results: [],
	};
	var result = currentList.reduce(process_messages, initialValue);
	var results = result.results;

	results.push(result.current);

	this.push(results);
}

function process_messages(aggregate, item) {
	if (item.from === aggregate.from) {
		aggregate.current.push(item);
		return aggregate;
	}
	else {
		if(aggregate.current.length !== 0)
			aggregate.results.push(aggregate.current);
		aggregate.from = item.from;
		aggregate.current = [item];
		return aggregate;
	}
}
